import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { InsightService } from '../insight-new/insight.service';
import { Dependencies } from '../store';
import { PayloadAction } from '../store.model';

import { CardType } from './models/card-type.model';
import { PerformanceCard } from './models/performance-card.model';
import {
    ActionType,
    reloadResult,
    ReloadResultAction,
    RootReloadAction,
} from './my-performance-card.action';

export interface ChainGroup<TPayload> {
    root: TPayload;

    performanceCard?: PerformanceCard;
}

const reload = (
    action: ActionsObservable<PayloadAction<ActionType, RootReloadAction>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, ReloadResultAction>> =>
    action.pipe(
        ofType(ActionType.MY_PERFORMANCE_CARD__ROOT__RELOAD),
        switchMap((act) => {
            const service = deps.injector.get<InsightService>(InsightService);
            const grp: ChainGroup<RootReloadAction> = { root: act.payload };
            const obses: [Observable<PerformanceCard>] = [
                of(null).pipe(
                    service.retrievePerformanceCard(() => ({
                        userId: act.payload.userId,
                        cardType: CardType.DEFAULT,
                    })),
                    tap((ret) => {
                        grp.performanceCard = ret;
                    }),
                ),
            ];
            return forkJoin(obses).pipe(
                map(() => {
                    return reloadResult(
                        {
                            ...act.payload,
                            performanceCard: grp.performanceCard,
                        },
                        act.storePath,
                    );
                }),
                catchError(() =>
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );

export const performanceCardEpics = [reload];
